import Embed from '@components/Embed';
import config from '@config/index';
import type {EmbedProps} from '@interfaces/Embed';
import {setCurrentLanguage} from '@services/i18n';
import {maybeAddContainer} from '@utils/layout';
import {loadStyles} from '@utils/script';
import {getContainerId, getEmbedParams, getEmbedType, getLanguage} from '@utils/scriptParams';
import {createRoot} from 'react-dom/client';
import {QueryClient, QueryClientProvider} from 'react-query';
import type {EmbedType} from '@constants/embedType';

function psInit() {
    setCurrentLanguage(getLanguage());
    initEmbed(getEmbedType(), getContainerId(), getEmbedParams());
}

function initEmbed(embedType: EmbedType, containerId: string, params: EmbedProps) {
    loadStyles(embedType);

    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                refetchOnWindowFocus: false,
                retry: 2,
            },
        },
    });

    maybeAddContainer(config.popupContainerId);
    maybeAddContainer(config.snackbarContainerId);

    const container = document.getElementById(containerId);
    const root = createRoot(container!);
    root.render(
        <QueryClientProvider client={queryClient}>
            <Embed type={embedType} params={params} />
        </QueryClientProvider>,
    );
}

psInit();
